export const environment = {
  isBrowser: false,
  isNode:
    false,
  isWebWorker:
    false,
  isServiceWorker:
    false,

  // Helper methods
  hasNativeWebSocket(): boolean {
    return true
  },

  supportsWebSocket(): boolean {
    // First check for native support
    if (this.hasNativeWebSocket()) {
      return true
    }

    // For Node.js without native support, try to load ws package
    // if (this.isNode) {
    //   try {
    //     // Dynamic require to avoid bundling ws package in browser builds
    //     const WebSocket = (globalThis as any).require?.('ws')
    //     return typeof WebSocket === 'function'
    //   }
    //   catch {
    //     return false
    //   }
    // }

    return false
  },

  supportsLocalStorage(): boolean {
    try {
      return this.isBrowser && 'localStorage' in window && window.localStorage !== null
    }
    catch {
      return false
    }
  },

  supportsCrypto(): boolean {
    return (
      (this.isBrowser && 'crypto' in window)
      || (this.isWebWorker && 'crypto' in self)
      || (this.isNode && 'crypto' in globalThis)
    )
  },

  // Helper to get the appropriate global object
  getGlobalObject(): any {
    if (this.isBrowser)
      return window
    if (this.isWebWorker || this.isServiceWorker)
      return self
    if (this.isNode)
      return global
    return globalThis
  },
}
